<prime-button
  (onClick)="userMenu.toggle($event)"
  ariaLabel="Profile menu"
  icon="pi pi-bars"
  size="small"
  [disabled]="disabled()"
></prime-button>
<p-popover
  #userMenu
  ariaLabel="Profile menu"
  appendTo="body"
  pinnaklPopoverRight
  styleClass="p-popover-no-arrow tw:py-2 tw:w-56 tw:mt-0 tw:mr-2"
>
  <div class="tw:w-full tw:flex tw:flex-col">
    <ng-content />
    <div class="tw:px-2 tw:w-full">
      <button
        type="button"
        [disabled]="disabled()"
        (click)="close(); logoutRequested.emit()"
        class="tw:flex tw:w-full tw:p-2 tw:gap-2 tw:items-center tw:rounded-(--p-content-border-radius) tw:border-0 tw:border-none tw:bg-transparent tw:cursor-pointer tw:text-color tw:text-left tw:hover:bg-bluegray-100 tw:transition-colors tw:duration-300"
      >
        <i
          aria-hidden="true"
          class="pi pi-sign-out tw:shrink-0 tw:text-muted-color"
        ></i>
        <span>Logout</span>
      </button>
    </div>
  </div>
</p-popover>
